import React, { Fragment, useEffect, useRef, useState } from 'react';
import AdminApi from "../utils/AdminApi"
import '../styles/Templates.css'
import {  Box, Button, ButtonGroup, Chip, Grid, Menu, MenuItem, Paper, TextField, Typography } from '@mui/material';
import AceEditor from 'react-ace';
import 'ace-builds/src-noconflict/mode-html';
import 'ace-builds/src-noconflict/mode-css';
import 'ace-builds/src-noconflict/theme-tomorrow';
import { Fields } from './Fields';
import { FIELD_TYPES } from '../utils/utils';
import JSData from './JSData';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import RemoveIcon from '@mui/icons-material/Remove';
import DeleteIcon from '@mui/icons-material/Delete';
import OpenWithIcon from '@mui/icons-material/OpenWith';

function ElementsOptions(props) {
    const anchorOptions = props.anchorOptions
    const elementsOptions = props.elementsOptions || []

    const handleClose = () => {
        props.setAnchorOptions(null);
    };

    const selectOption = option => {
        props.createElement(option)
    }
  
    return (
      <div>
        <Menu
            id="elementsOptions"
            anchorEl={anchorOptions}
            keepMounted
            open={Boolean(anchorOptions)}
            onClose={handleClose}
        >
            {elementsOptions.map(element => 
                <MenuItem key={element} onClick={()=>selectOption(element)}>{element}</MenuItem>
            )}
        </Menu>
      </div>
    );
}

function EmailElement(props) {
    const element = props.element || {}
    const elementsParams = props.elementsParams || {}

    const [expanded, setExpanded] = useState(false);

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    const getValue = (name, defaultValue) => {
        return element[name] || defaultValue
    }

    const handleChangeField = e => {
        const { name, value } = e.target;

        props.handleElementChange(props.index, name, value);
    };

    const handleDeleteElement = e => {
        props.handleDeleteElement(props.index)
    }

    return (
        <Paper style={{margin:'4px', padding: 8}} elevation={1}>
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                {props.dragElement}
                <Typography><b>{element.type}</b></Typography>
                <div>
                    <IconButton size='small' onClick={handleDeleteElement}>
                        <DeleteIcon/>
                    </IconButton>
                    <IconButton size='small' onClick={handleExpandClick} style={{marginLeft: 16}}>
                        {expanded?<RemoveIcon />:<EditIcon />}
                    </IconButton>
                </div>
            </div>
            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <Fields fields={elementsParams.fields} getValue={getValue} handleChange={handleChangeField}/>
            </Collapse>
        </Paper>
    )
}

export default function EmailsTemplates(props) {
    const matchParams = props.matchParams || {}
    const templateFromLink = matchParams.template
    const isAdmin = props.isAdmin || false

    const [cells, setCells] = useState([]);
    const [htmlTemplates, setHtmlTemplates] = useState([]);
    const [fromOptions, setFromOptions] = useState([]);
    const [filteredTemplates, setFilteredTemplates] = useState([]);
    const [selectedTempalte, setSelectedTempalte] = useState({});
    const [mainTemplate, setMainTemplate] = useState({});
    const [emailParams, setEmailParams] = useState({});
    const [error, setError] = useState();
    const [sendingTest, setSendingTest] = useState(false);
    //const [creatingCopy, setCreatingCopy] = useState(false);

    const [display, setDisplay] = useState('both');
    const [mainContentEditor, setMainContentEditor] = useState('details');
    const [filterTamplates, setFilterTamplates] = useState('talentsNewsletters');

    const [sendTestTo, setSendTestTo] = useState('');
    //const [newNameForCopy, setNewNameForCopy] = useState('');

    const [preview, setPreview] = useState('');
    const [subjectPreview, setSubjectPreview] = useState('');
    const [newPreviewNeeded, setNewPreviewNeeded] = useState(false);
    //const [isPreviewing, setIsPreviewing] = useState(false);
    const timeoutRef = useRef(null);
    const [newSubjectPreviewNeeded, setNewSubjectPreviewNeeded] = useState(false);

    const [newData, setNewData] = useState({});
    const [mainContent, setMainContent] = useState('');
    const [cssContent, setCssContent] = useState('');

    const [anchorOptions, setAnchorOptions] = useState(null);
    const [elementPosition, setElementPosition] = useState();

    const [elementsOptions, setElementsOptions] = useState({});
    const [expandedEmailSetting, setExpandedEmailSetting] = useState(true);

    const [dragFrom, setDragFrom] = useState();
    const [dragTo, setdragTo] = useState();

    useEffect(() => {
        if (htmlTemplates.length === 0) {
            AdminApi.getHtmlTemplates((results)=>{
                setHtmlTemplates(results.htmlTemplates || [])
                setEmailParams(results.params || [])
                setFromOptions(results.fromOptions || [])
                setCells(results.cells || [])
                setElementsOptions(results.elementsOptions || {})

                const foundedMainTemplate = (results.htmlTemplates || []).find( templates => templates.name === 'templateSupports' )
                setMainTemplate(foundedMainTemplate||{})

                if (templateFromLink){
                    const foundedTemplate = (results.htmlTemplates || []).find( templates => templates.name === templateFromLink )
                    if (foundedTemplate){
                        setSelectedTempalte(foundedTemplate)
                        setNewPreviewNeeded(true)
                        setNewSubjectPreviewNeeded(true)
                    }
                }
            }, (error) => {
                if(error&&error.response&&error.response.data){
                    setError(error.response.data)
                } else {
                    setError('Something went wrong')
                }
            })
        }
    }, [templateFromLink, htmlTemplates]);

    useEffect(() => {
        setFilteredTemplates(htmlTemplates.filter(htmlTemplate=>{
            switch(filterTamplates){
                case 'all':{
                    return htmlTemplate.active
                } case 'JobHunt':{
                    return (htmlTemplate.active && !htmlTemplate.isTalentsNewsletter && htmlTemplate.is_jobhunt)
                } case 'talentsNewsletters':{
                    return (htmlTemplate.isTalentsNewsletter)
                } case 'JobSwipe':{
                    return (htmlTemplate.active && !htmlTemplate.isTalentsNewsletter && !htmlTemplate.is_jobhunt)
                } case 'notActive':{
                    return !htmlTemplate.active
                } default: {
                    return true
                }
            }
        }))
    }, [filterTamplates, htmlTemplates]);

    /*useEffect(() => {
        if (newPreviewNeeded){
            const is_jobhunt = (newData.is_jobhunt === undefined) ? selectedTempalte.is_jobhunt : newData.is_jobhunt
            const isTalentsNewsletter = (newData.isTalentsNewsletter === undefined) ? selectedTempalte.isTalentsNewsletter : newData.isTalentsNewsletter
            const noMainHtml = (newData.noMainHtml === undefined) ? selectedTempalte.noMainHtml : newData.noMainHtml

            const simpleContent = (newData.simpleContent === undefined) ? selectedTempalte.simpleContent : newData.simpleContent

            let newPreview;

            if (noMainHtml){
                newPreview = newData.content || selectedTempalte.content;
            } else {
                newPreview = mainContent || mainTemplate.mainHtml;
                newPreview = newPreview.replace(/__content__/mgi, newData.content || selectedTempalte.content)
            }

            newPreview = newPreview.replace(/__css__/mgi, cssContent || mainTemplate.css)
            newPreview = newPreview.replace(/__simpleContent__/mgi, simpleContent)
            newPreview = newPreview.replace(/__logo__/mgi, is_jobhunt?`<a target="_blank" href="https://jobhunt.co.il" class="jobhuntLogo"><img src="https://www.jobhunt.co.il//wp-content/themes/jobboard/assets/images/jobhunt-logo-english.png" style="max-width: 250px;width: 100%;"></a>`:`<a target="_blank" href="<%=logoLinkClick%>" class="jobswipeLogo">JobSwipe</a>`)
            newPreview = newPreview.replace(/__sentFrom__/mgi, is_jobhunt?`JobHunt`:`JobSwipe`)


            newPreview = newPreview.replace(/__\^/mgi, '<')
            newPreview = newPreview.replace(/\^__/mgi, '>')

            newPreview = newPreview.replace(/_%=/mgi, '<%=')
            newPreview = newPreview.replace(/%_/mgi, '%>')

            let footerLinks = `<a href="<%=privacyLink%>" target="_blank">Privacy Policy</a>
            <span> | </span><a href="<%=settingsLink%>">Settings</a>
            <span> | </span><a href="<%=unsubscribe%>">Unsubscribe</a>`

            if(isTalentsNewsletter){
                footerLinks = `<a href="<%=privacyLink%>" target="_blank">Privacy Policy</a>
                    <span> | </span><a href="<%=unsubscribeTNS%>">Unsubscribe</a>`
            }

            newPreview = newPreview.replace(/__footerLinks__/mgi, footerLinks);
    
            for (let key in emailParams) {
                if (emailParams.hasOwnProperty(key)) {
                    const myRegExp = new RegExp('<%=' + key + '%>','mgi');
                    newPreview = newPreview.replace(myRegExp, emailParams[key]);
                }
            }

            const templatesNameRegExp = new RegExp('<%=templatesName%>','mgi');
            newPreview = newPreview.replace(templatesNameRegExp, (newData.name || selectedTempalte.name));

            const from = newData.from || selectedTempalte.from
            const fromObj = newData.fromObj || selectedTempalte.fromObj || {}

            let signature = ''
            if (from && fromObj.signatureName){
                signature = `<a href="https://www.jobhunt.co.il?utm_source=${selectedTempalte.name}&amp;utm_medium=email&amp;utm_campaign=email_campaign&amp;utm_content=signature"><img style="max-width: 500px;width: 100%;" src="https://www.jobhunt.co.il//wp-content/themes/jobboard/assets/500/Email-${fromObj.signatureName}-Signature.png" alt="${fromObj.signatureName} Signature"></a>`
            }

            newPreview = newPreview.replace(new RegExp('<%=signature%>','mgi'), signature);

            let dontReplyPart = '<span>Please do not reply to this email, as we are unable to respond from this email address.</span><br>'
            if (from && fromObj.replyTo){
                dontReplyPart = ''
            }
            newPreview = newPreview.replace(new RegExp('<%=dontReply%>','mgi'), dontReplyPart);

            setPreview(newPreview)
            setNewPreviewNeeded(false)
        }
    }, [newPreviewNeeded, selectedTempalte, mainTemplate, mainContent, cssContent, emailParams, newData]);*/

    useEffect(() => {
        if (!newPreviewNeeded) return;
    
        //setIsPreviewing(true);

        const runPreview = () => {
            const is_jobhunt = (newData.is_jobhunt === undefined) ? selectedTempalte.is_jobhunt : newData.is_jobhunt
            const isTalentsNewsletter = (newData.isTalentsNewsletter === undefined) ? selectedTempalte.isTalentsNewsletter : newData.isTalentsNewsletter
            const noMainHtml = (newData.noMainHtml === undefined) ? selectedTempalte.noMainHtml : newData.noMainHtml

            const simpleContent = (newData.simpleContent === undefined) ? selectedTempalte.simpleContent : newData.simpleContent

            let newPreview;

            if (noMainHtml){
                newPreview = newData.content || selectedTempalte.content;
            } else {
                newPreview = mainContent || mainTemplate.mainHtml;
                newPreview = newPreview.replace(/__content__/mgi, newData.content || selectedTempalte.content)
            }

            newPreview = newPreview.replace(/__css__/mgi, cssContent || mainTemplate.css)
            newPreview = newPreview.replace(/__simpleContent__/mgi, simpleContent)
            newPreview = newPreview.replace(/__logo__/mgi, is_jobhunt?`<a target="_blank" href="https://jobhunt.co.il" class="jobhuntLogo"><img src="https://www.jobhunt.co.il//wp-content/themes/jobboard/assets/images/jobhunt-logo-english.png" style="max-width: 250px;width: 100%;"></a>`:`<a target="_blank" href="<%=logoLinkClick%>" class="jobswipeLogo">JobSwipe</a>`)
            newPreview = newPreview.replace(/__sentFrom__/mgi, is_jobhunt?`JobHunt`:`JobSwipe`)


            newPreview = newPreview.replace(/__\^/mgi, '<')
            newPreview = newPreview.replace(/\^__/mgi, '>')

            newPreview = newPreview.replace(/_%=/mgi, '<%=')
            newPreview = newPreview.replace(/%_/mgi, '%>')

            let footerLinks = `<a href="<%=privacyLink%>" target="_blank">Privacy Policy</a>
            <span> | </span><a href="<%=settingsLink%>">Settings</a>
            <span> | </span><a href="<%=unsubscribe%>">Unsubscribe</a>`

            if(isTalentsNewsletter){
                footerLinks = `<a href="<%=privacyLink%>" target="_blank">Privacy Policy</a>
                    <span> | </span><a href="<%=unsubscribeTNS%>">Unsubscribe</a>`
            }

            newPreview = newPreview.replace(/__footerLinks__/mgi, footerLinks);

            for (let key in emailParams) {
                if (emailParams.hasOwnProperty(key)) {
                    const myRegExp = new RegExp('<%=' + key + '%>','mgi');
                    newPreview = newPreview.replace(myRegExp, emailParams[key]);
                }
            }

            const templatesNameRegExp = new RegExp('<%=templatesName%>','mgi');
            newPreview = newPreview.replace(templatesNameRegExp, (newData.name || selectedTempalte.name));

            const from = newData.from || selectedTempalte.from
            const fromObj = newData.fromObj || selectedTempalte.fromObj || {}

            let signature = ''
            if (from && fromObj.signatureName){
                signature = `<a href="https://www.jobhunt.co.il?utm_source=${selectedTempalte.name}&amp;utm_medium=email&amp;utm_campaign=email_campaign&amp;utm_content=signature"><img style="max-width: 500px;width: 100%;" src="https://www.jobhunt.co.il//wp-content/themes/jobboard/assets/500/Email-${fromObj.signatureName}-Signature.png" alt="${fromObj.signatureName} Signature"></a>`
            }

            newPreview = newPreview.replace(new RegExp('<%=signature%>','mgi'), signature);

            let dontReplyPart = '<span>Please do not reply to this email, as we are unable to respond from this email address.</span><br>'
            if (from && fromObj.replyTo){
                dontReplyPart = ''
            }
            newPreview = newPreview.replace(new RegExp('<%=dontReply%>','mgi'), dontReplyPart);

            setPreview(newPreview)
            setNewPreviewNeeded(false)
        };
    
        // Clear any previous timeout
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
    
        // Set a new timeout
        timeoutRef.current = setTimeout(() => {
            runPreview();              // ✅ Always run the latest change
            //setIsPreviewing(false);
            setNewPreviewNeeded(false); // Reset flag
        }, 1); 
    
        // Cleanup
        return () => clearTimeout(timeoutRef.current);
    }, [newPreviewNeeded, selectedTempalte, mainTemplate, mainContent, cssContent, emailParams, newData]);

    useEffect(() => {
        if (newSubjectPreviewNeeded){
            let newSubjectPreview = newData.subject || selectedTempalte.subject
            for (let key in emailParams) {
                if (emailParams.hasOwnProperty(key)) {
                    var myRegExp = new RegExp('<%=' + key + '%>','mgi');
                    newSubjectPreview = newSubjectPreview.replace(myRegExp, emailParams[key]);
                }
            }

            setSubjectPreview(newSubjectPreview)
            setNewSubjectPreviewNeeded(false)
        }
    }, [newSubjectPreviewNeeded, emailParams, newData, selectedTempalte]);

    const getValue = (name, defaultValue) => {
        if (newData[name] !== undefined){
            return newData[name]
        } else if (selectedTempalte[name] !== undefined){
            return selectedTempalte[name]
        } else {
            return defaultValue
        }
    }

    const handleCreateNewsletter = () => {
        AdminApi.createEmailTemplate({},(response)=>{
            setHtmlTemplates(response.htmlTemplates || [])

            const foundedSelectedTemplate = (response.htmlTemplates || []).find( templates => templates.name === response.name )

            if (foundedSelectedTemplate){
                editTemplate(foundedSelectedTemplate)
            }
        }, (error) => {
            props.showMessageDialog('Error', error.error)
        })
    }

    const editTemplate = (newTemplate) => {
        setSelectedTempalte({...newTemplate})
        props.changeUrl('/templates/' + (newTemplate.name||''))

        if (newTemplate.name){
            setNewPreviewNeeded(true)
            setNewSubjectPreviewNeeded(true)
        }

        setNewData({})
        setMainContent('')
        setCssContent('')
    }

    const onChangeMainContent = (newMainContent) => {
        setMainContent(newMainContent)
        setNewPreviewNeeded(true)
    }

    const onSaveMainContent = () => {
        let params = {};

        params.name = 'templateSupports'
        params.mainHtml = mainContent

        AdminApi.saveHtmlTemplate(params,(results)=>{
            setHtmlTemplates(results.htmlTemplates || [])
            setEmailParams(results.params || [])

            const foundedMainTemplate = (results.htmlTemplates || []).find( templates => templates.name === 'templateSupports' )
            setMainTemplate(foundedMainTemplate||{})
            setMainContent('')

            props.showMessageDialog( 'Saved', 'This will affect all templates')
        }, (error) => {
            props.showMessageDialog('Error', error.error)
        })
    }

    const onChangeCssContent = (newCssContent) => {
        setCssContent(newCssContent)
        setNewPreviewNeeded(true)
    }

    const onSaveCssContent = () => {
        let params = {};

        params.name = 'templateSupports'
        params.css = cssContent

        AdminApi.saveHtmlTemplate(params,(results)=>{
            setHtmlTemplates(results.htmlTemplates || [])
            setEmailParams(results.params || [])

            const foundedMainTemplate = (results.htmlTemplates || []).find( templates => templates.name === 'templateSupports' )
            setMainTemplate(foundedMainTemplate||{})
            setCssContent('')

            props.showMessageDialog( 'Saved', 'This will affect all templates')
        }, (error) => {
            props.showMessageDialog('Error', error.error)
        })
    }

    const onChangeContent = (newContent) => {
        setNewData({...newData, content: newContent})
        setNewPreviewNeeded(true)
    }

    const handleChangeField = e => {
        let newNewDate = {...newData}
        newNewDate[e.target.name] = e.target.value

        if (e.target.name === 'from'){
            if (e.target.value){
                newNewDate.fromObj = fromOptions.find( fromOption => fromOption.value === e.target.value )
            } else {
                newNewDate.fromObj = {}
            }
        }

        console.log(newNewDate)
        setNewData(newNewDate)

        if (e.target.name === 'subject'){
            setNewSubjectPreviewNeeded(true)
        }

        if (e.target.name === 'is_jobhunt' || e.target.name === 'from'){
            setNewPreviewNeeded(true)
        }
    };

    const onSaveTemplate = () => {
        let params = {...newData};

        params.id = selectedTempalte._id.toString()
        
        AdminApi.saveHtmlTemplate(params,(results)=>{
            setHtmlTemplates(results.htmlTemplates || [])

            const foundedSelectedTemplate = (results.htmlTemplates || []).find( templates => templates._id.toString() === selectedTempalte._id.toString() )

            if (foundedSelectedTemplate && newData.name && newData.name !== selectedTempalte.name){
                props.changeUrl('/templates/' + (foundedSelectedTemplate.name||''))
            }
            setSelectedTempalte(foundedSelectedTemplate||{})
            setNewData({})

            props.showMessageDialog( 'Saved', 'Saved')
        }, (error) => {
            props.showMessageDialog('Error', error.error)
        })
    }

    const handleEditRow=(row, params={})=>{
        editTemplate(row)
    }

    const handleSendTestTo = (event) => {
        setSendTestTo(event.target.value);
    };

    /*const handleNewNameForCopy = (event) => {
        setNewNameForCopy(event.target.value);
    }

    const handleCreateCopy = e => {
        e.preventDefault();

        const paramsToPass = {
            name: selectedTempalte.name,
            newName: newNameForCopy,
        }

        setCreatingCopy(true)

        AdminApi.copyHtmlTemplate(paramsToPass,(results)=>{
            setCreatingCopy(false)
        }, (error) => {
            setCreatingCopy(false)

            if(error&&error.response&&error.response.data){
                setError(error.response.data)
            } else {
                setError('Something went wrong')
            }
        })
    }*/

    const handleReadyActivate = () => {
        const paramsToPass = {
            template: selectedTempalte.name,
            params: emailParams
        }

        setSendingTest(true)

        AdminApi.readyActivateHtmlTemplate(paramsToPass,(results)=>{
            setHtmlTemplates(results.htmlTemplates || [])

            const foundedSelectedTemplate = (results.htmlTemplates || []).find( templates => templates.name === selectedTempalte.name )
            setSelectedTempalte(foundedSelectedTemplate||{})

            props.showMessageDialog('Email Sent','')
            setSendingTest(false)
        }, (error) => {
            setSendingTest(false)

            if(error&&error.response&&error.response.data){
                setError(error.response.data)
            } else {
                setError('Something went wrong')
            }
        })
    }

    const handleActivate = () => {
        const paramsToPass = {
            template: selectedTempalte.name
        }

        setSendingTest(true)

        AdminApi.activateNewsletter(paramsToPass,(results)=>{
            setHtmlTemplates(results.htmlTemplates || [])

            const foundedSelectedTemplate = (results.htmlTemplates || []).find( templates => templates.name === selectedTempalte.name )
            setSelectedTempalte(foundedSelectedTemplate||{})

            setSendingTest(false)

            props.showMessageDialog( 'Activated')
        }, (error) => {
            setSendingTest(false)

            if(error&&error.response&&error.response.data){
                setError(error.response.data)
            } else {
                setError('Something went wrong')
            }
        })
        /*let params = {active : true};

        params.name = selectedTempalte.name

        setSendingTest(true)
        
        AdminApi.saveHtmlTemplate(params,(results)=>{
            setHtmlTemplates(results.htmlTemplates || [])
            setEmailParams(results.params || [])

            const foundedSelectedTemplate = (results.htmlTemplates || []).find( templates => templates.name === selectedTempalte.name )
            setSelectedTempalte(foundedSelectedTemplate||{})

            setSendingTest(false)

            props.showMessageDialog( 'Activated')
        }, (error) => {
            setSendingTest(false)
            props.showMessageDialog('Error', error.error)
        })*/
    }

    const handleSendTest = e => {
        e.preventDefault();

        const paramsToPass = {
            template: selectedTempalte.name,
            email: sendTestTo,
            params: emailParams
        }

        setSendingTest(true)

        AdminApi.testHtmlTemplate(paramsToPass,(results)=>{
            setHtmlTemplates(results.htmlTemplates || [])

            const foundedSelectedTemplate = (results.htmlTemplates || []).find( templates => templates.name === selectedTempalte.name )
            setSelectedTempalte(foundedSelectedTemplate||{})

            props.showMessageDialog('Email Sent','')
            setSendingTest(false)
        }, (error) => {
            setSendingTest(false)

            if(error&&error.response&&error.response.data){
                setError(error.response.data)
            } else {
                setError('Something went wrong')
            }
        })
    }

    const addElement = (event,insertIndex) =>{
        setAnchorOptions(event.currentTarget);
        setElementPosition(insertIndex)
    }

    const createElement = type => {
        let newElements = [...getValue('templateElements', [])]
        newElements.splice(elementPosition, 0, {...elementsOptions[type].defaultValue});

        const renderedHtml = renderElements(newElements)

        setNewData({...newData, templateElements: newElements, simpleContent: renderedHtml})
        setAnchorOptions(null)
        setElementPosition()
        setNewPreviewNeeded(true)
    }

    const handleElementChange = (index, name, value) => {
        let newElements = [...getValue('templateElements', [])]
        newElements[index][name] = value

        const renderedHtml = renderElements(newElements)

        setNewData({...newData, templateElements: newElements, simpleContent: renderedHtml})
        setNewPreviewNeeded(true)
    }

    const handleDeleteElement = (indexToRemove) => {
        const newElements = getValue('templateElements', []).filter((element, i) => i !== indexToRemove);

        const renderedHtml = renderElements(newElements)

        setNewData({...newData, templateElements: newElements, simpleContent: renderedHtml})
        setNewPreviewNeeded(true)
    }

    const renderElements = elements => {
        let renderedHtml = ''

        elements.forEach(element => {
            let elementHTML = elementsOptions[element.type].HTML || ''
            if (!element.link && elementsOptions[element.type].noLinkHTML){
                elementHTML = elementsOptions[element.type].noLinkHTML
            }

            elementsOptions[element.type].fields.forEach(field => {
                let fieldValue = element[field.name]
                if (field.withBold){
                    fieldValue = fieldValue
                        .replace(/\\\*/g, '__ESCAPED_STAR__')
                        .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
                        .replace(/__ESCAPED_STAR__/g, '*');
                }
                if (field.list){
                    fieldValue = (fieldValue.trim().match(/-.*(?:\n(?!-).*)*/g) || [])
                        .map(item => elementsOptions[element.type].listItemHTML.replace('<%=listItem%>', item.replace(/^-\s?/, '').trim()))
                        .join('\n')
                }

                const myRegExp = new RegExp('<%=' + field.name + '%>','mgi');
                elementHTML = elementHTML.replace(myRegExp, fieldValue);
            });
            renderedHtml += elementHTML
        });

        return renderedHtml
    }

    const handleDragStart = (index) => {
        setDragFrom(index)
    }

    const handleDragEnter = (index) => {
        if (dragTo!==index){
            setdragTo(index)
        }
    }

    const handleDragDrop = () => {
        if (dragFrom!==undefined && dragTo!==undefined && dragFrom!==dragTo){
            let newElements = getValue('templateElements', []).filter((element,index)=>(index!==dragFrom))
            newElements.splice(dragTo, 0, {...getValue('templateElements', [])[dragFrom]});

            const renderedHtml = renderElements(newElements)

            setNewData({...newData, templateElements: newElements, simpleContent: renderedHtml})
            setNewPreviewNeeded(true)
        }

        setDragFrom()
        setdragTo()
    }

    const setSendTo = newValue => {
        setNewData({...newData, sendTo: newValue})
    }

    const canReadyActivate = ((selectedTempalte.sentTest||'') !== '' && (selectedTempalte.subject||'')!== '' && (selectedTempalte.from||'')!=='')

    const canDragElement = (getValue('templateElements', []).length>1)

    const sendTo = getValue('sendTo', [])

    const fields = [
        { name: 'subject', label: 'Subject', defaultValue: '', type:FIELD_TYPES.TEXT, sm:12}, 
        { name: 'name', label: 'Name', defaultValue: '', type:FIELD_TYPES.TEXT, sm:6, helperText: 'uniqye english text without spaces'}, 
        { name: 'from', label: 'From', defaultValue: '', options:fromOptions, type:FIELD_TYPES.SELECT, sm:6}, 
        { name: 'is_jobhunt', label: 'Jobhunt', defaultValue: false, type:FIELD_TYPES.CHECK_BOX, sm:6, hide:(!isAdmin&&getValue('isTalentsNewsletter',false))}, 
        { name: 'isTalentsNewsletter', label: 'Talents Newsletter', defaultValue: false, type:FIELD_TYPES.CHECK_BOX, sm:6, hide:(!isAdmin&&getValue('isTalentsNewsletter',false))}, 
        { name: 'daysSendAfter', label: 'Days Send After', defaultValue: '', type:FIELD_TYPES.TEXT, sm:6, inputType:'number', hide:((!isAdmin&&getValue('isTalentsNewsletter',false)) || (isAdmin &&!getValue('isTalentsNewsletter',false)))}, 
        { name: 'emailOverride', label: 'Email Override', defaultValue: '', type:FIELD_TYPES.TEXT, sm:6, hide: !isAdmin},
        { name: 'active', label: 'Active', defaultValue: false, type:FIELD_TYPES.CHECK_BOX, sm:6, hide: !isAdmin}, 
        { name: 'noMainHtml', label: 'No Main Html', defaultValue: false, type:FIELD_TYPES.CHECK_BOX, sm:6, hide: !isAdmin}, 
    ]

    return (
        <div className="templatesContainer">
            {(error)&&<Typography color="error">{error}</Typography>}
            {selectedTempalte.name?<>
                {/*<Prompt
                    when={(Object.keys(newData).length > 0 || mainContent || cssContent)}
                    message='You have unsaved changes, are you sure you want to leave?'
                />*/}
                <Grid container spacing={3}>
                    <Grid item sm={6} xs={12}>
                        <div style={{margin:"8px 0"}}><span className="link" onClick={()=>{editTemplate({})}}>Back to template list</span></div>
                    </Grid>
                    <Grid item sm={6} xs={12} style={{textAlign:"right"}}>
                        <ButtonGroup size="small">
                            <Button disabled={(display==='code')} onClick={() => setDisplay('code')}>Edit</Button>
                            <Button disabled={(display==='both')} onClick={() => setDisplay('both')}>Both</Button>
                            <Button disabled={(display==='preview')} onClick={() => setDisplay('preview')}>Preview</Button>
                        </ButtonGroup>
                    </Grid>
                </Grid>
                <Grid container spacing={3} className="unscrolledColumns">
                    {(display==='code' || display==='both')&&<Grid item sm={(display==='both')?5:12} xs={12} className="column">
                        {isAdmin&&<div style={{marginBottom:8}}>
                            <Button size="small" style={(Object.keys(newData).length > 0)?{borderBottom:'2px solid red'}:{}} disabled={(mainContentEditor==='details')} onClick={() => setMainContentEditor('details')}>Details</Button>
                            <Button size="small" style={newData.content?{borderBottom:'2px solid red'}:{}} disabled={(mainContentEditor==='html')} onClick={() => setMainContentEditor('html')}>HTML</Button>
                            <Button size="small" style={mainContent?{borderBottom:'2px solid red'}:{}} disabled={(mainContentEditor==='mainHtml')} onClick={() => setMainContentEditor('mainHtml')}>Main HTML</Button>
                            <Button size="small" style={cssContent?{borderBottom:'2px solid red'}:{}} disabled={(mainContentEditor==='mainCss')} onClick={() => setMainContentEditor('mainCss')}>Main CSS</Button>
                            <Button size="small" disabled={(mainContentEditor==='params')} onClick={() => setMainContentEditor('params')}>Params</Button>
                        </div>}
                        {(mainContentEditor==='mainHtml')&&<div style={{width:'100%'}}>
                            <AceEditor
                                mode='html'
                                theme="tomorrow"
                                onChange={onChangeMainContent}
                                name="Content"
                                value={mainContent || mainTemplate.mainHtml}
                                fontSize={16}
                                width="100%"
                                editorProps={{$blockScrolling: true}}
                                setOptions={{tabSize: 2}}
                            />
                            <Button style={{marginTop:16}} size='small' variant="contained" color="primary" onClick={onSaveMainContent} aria-label="Save">Save</Button>   
                        </div>}
                        {(mainContentEditor==='mainCss')&&<div style={{width:'100%'}}>
                            <AceEditor
                                mode='css'
                                theme="tomorrow"
                                onChange={onChangeCssContent}
                                name="Content"
                                value={cssContent || mainTemplate.css}
                                fontSize={16}
                                width="100%"
                                editorProps={{$blockScrolling: true}}
                                setOptions={{tabSize: 2}}
                            />
                            <Button style={{marginTop:16}} size='small' variant="contained" color="primary" onClick={onSaveCssContent} aria-label="Save">Save</Button>
                        </div>}
                        {(mainContentEditor==='params')&&<Grid container spacing={3}>
                            {Object.entries(emailParams).map(param => 
                                <Grid key={param[0]} item sm={6} xs={12}>
                                    <TextField
                                        variant="standard"
                                        label={param[0]}
                                        value={param[1]}
                                        //onChange={onChangeSubject}
                                        margin="none"
                                        fullWidth />
                                </Grid>
                            )}
                        </Grid>}
                        {(mainContentEditor==='details')&&<>
                            <Paper style={{margin:'4px', padding: 8}} elevation={1}>
                                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                    <Typography><b>Email Settings</b></Typography>
                                    <div>
                                        <IconButton size='small' onClick={()=>{setExpandedEmailSetting(!expandedEmailSetting)}}>
                                            {expandedEmailSetting?<RemoveIcon />:<EditIcon />}
                                        </IconButton>
                                    </div>
                                </div>
                                <Collapse in={expandedEmailSetting} timeout="auto" unmountOnExit>
                                    {/*<Box style={{display: 'flex', gap: 8, alignItems: 'center'}}>
                                        <Typography><strong>Send to:</strong></Typography>
                                        <Chip size='small' label="Everyone" onClick={()=>setSendTo([])} variant={(sendTo.length === 0)?'filled':'outlined'} color={(sendTo.length === 0)?'primary':'default'}/>
                                        <Chip size='small' label="Very relevant" onClick={()=>setSendTo(["Very relevant"])} variant={sendTo.includes('Very relevant')?'filled':'outlined'} color={sendTo.includes('Very relevant')?'primary':'default'} />
                                    </Box>*/}
                                    <Fields fields={fields} getValue={getValue} handleChange={handleChangeField}/>
                                </Collapse>
                            </Paper>

                            {(isAdmin || !selectedTempalte.active)&&<Paper style={{margin:'4px', padding: 8}} elevation={1}>
                                <div>
                                    {(isAdmin || !selectedTempalte.active)&&<Button style={{marginRight:8}} size='small' variant="contained" color="primary" onClick={onSaveTemplate} aria-label="Save">Save</Button>}
                                    {(!selectedTempalte.active)&&<Button style={{marginRight:8}} disabled={sendingTest || !canReadyActivate} size='small' variant="contained" color="primary" onClick={handleReadyActivate}>Ready To Activate</Button>}
                                    {(!selectedTempalte.active)&&<Button disabled={sendingTest || !selectedTempalte.clickedReady || !canReadyActivate} size='small' variant="contained" color="primary" onClick={handleActivate}>Activate</Button>}
                                </div>
                            </Paper>}

                            <ElementsOptions anchorOptions={anchorOptions} setAnchorOptions={setAnchorOptions} createElement={createElement} elementsOptions={Object.keys(elementsOptions)}/>

                            <div style={{textAlign: 'center'}}>
                                <span onClick={event=>addElement(event, 0)} style={{color: '#396a92', cursor: 'pointer', margin: 4, display: 'inline-block'}}>+add email element here</span>
                            </div>
                            {getValue('templateElements', []).map((element, index) => 
                                <Fragment key={index}>
                                    <div style={{opacity:((dragFrom === index)?0.2:1)}} draggable={canDragElement && dragFrom}
                                        onDragEnter={(e)=>{
                                            if(canDragElement){
                                                e.preventDefault();
                                                handleDragEnter(index)
                                            }
                                        }}
                                        onDragOver={e => {
                                            if(canDragElement){
                                                e.dataTransfer.dropEffect = "move";
                                                e.preventDefault()
                                            }
                                        }}
                                        onDragEnd={(e)=>{
                                            if(canDragElement){handleDragDrop()}
                                        }}>
                                        <EmailElement 
                                            element={element} 
                                            index={index} 
                                            elementsParams={elementsOptions[element.type]} 
                                            handleElementChange={handleElementChange} 
                                            handleDeleteElement={handleDeleteElement}
                                            dragElement={(<div draggable={canDragElement}
                                                onDragStart={(e)=>{
                                                    if(canDragElement){handleDragStart(index)}
                                                }}
                                                ><OpenWithIcon color='primary'/></div>
                                            )}
                                        />     
                                    </div>
                                    <div style={{textAlign: 'center'}}>
                                        <span onClick={event=>addElement(event, index+1)} style={{color: '#396a92', cursor: 'pointer', margin: 4, display: 'inline-block'}}>+add email element here</span>
                                    </div>
                                </Fragment>
                            )}
                            
                            {(isAdmin || !selectedTempalte.active)&&<Paper style={{margin:'4px', padding: 8}} elevation={1}>
                                <div>
                                    {(isAdmin || !selectedTempalte.active)&&<Button style={{marginRight:8}} size='small' variant="contained" color="primary" onClick={onSaveTemplate} aria-label="Save">Save</Button>}
                                    {(!selectedTempalte.active)&&<Button style={{marginRight:8}} disabled={sendingTest || !canReadyActivate} size='small' variant="contained" color="primary" onClick={handleReadyActivate}>Ready To Activate</Button>}
                                    {(!selectedTempalte.active && selectedTempalte.isTalentsNewsletter)&&<Button disabled={sendingTest || !selectedTempalte.clickedReady || !canReadyActivate} size='small' variant="contained" color="primary" onClick={handleActivate}>Activate</Button>}
                                </div>
                            </Paper>}
                            {/*<Paper style={{margin:'4px', padding: 8}} elevation={1}>
                                <form onSubmit={handleCreateCopy}>
                                    <div style={{display: 'flex',alignItems: 'center', marginBottom:8}}>
                                        <TextField label="New name" onChange={handleNewNameForCopy} value={newNameForCopy}/>
                                        <Button disabled={creatingCopy || !newNameForCopy} variant='contained' color='primary' size="small" type="submit">Create Copy</Button>
                                    </div>
                                </form>
                            </Paper>*/}
                        </>}
                        {(mainContentEditor==='html')&&<div style={{width:'100%'}}>
                            <AceEditor
                                mode='html'
                                theme="tomorrow"
                                onChange={onChangeContent}
                                name="Content"
                                value={getValue('content', '')}
                                fontSize={16}
                                width="100%"
                                editorProps={{$blockScrolling: true}}
                                setOptions={{tabSize: 2}}
                            />
                            <Button style={{marginTop:16}} size='small' variant="contained" color="primary" onClick={onSaveTemplate} aria-label="Save">Save</Button> 
                        </div>} 
                    </Grid>}
                    {(display==='preview' || display==='both')&&<Grid item sm={(display==='both')?7:12} xs={12} className="column">
                        <form onSubmit={handleSendTest}>
                            <div style={{display: 'flex',alignItems: 'center', marginBottom:8}}>
                                <TextField
                                    variant="standard"
                                    name='email'
                                    label="Send Test To"
                                    type='email'
                                    onChange={handleSendTestTo}
                                    value={sendTestTo} />
                                <Button disabled={sendingTest || !sendTestTo || Object.keys(newData).length > 0 || mainContent || cssContent} variant='contained' color='primary' size="small" type="submit">Send Test</Button>
                            </div>
                        </form>
                        <Typography dir="auto" variant='h6' style={{marginBottom:8}}>{subjectPreview}</Typography>
                        <div dangerouslySetInnerHTML={{__html: preview}} />
                    </Grid>}
                </Grid>
            </>:<>
                <Paper style={{margin:'0 4px', padding: 8, display: 'flex', justifyContent: 'space-between'}} elevation={1}>
                    <div>
                        {(filterTamplates==='talentsNewsletters')&&<Button color='primary' size='small' variant='contained' onClick={handleCreateNewsletter}>Create NewsLetter</Button>}
                    </div>
                    <div>
                        <Button color='primary' size='small' disabled={(filterTamplates==='all')} onClick={() => setFilterTamplates('all')}>All</Button>
                        <Button color='primary' size='small' disabled={(filterTamplates==='JobHunt')} onClick={() => setFilterTamplates('JobHunt')}>JobHunt</Button>
                        <Button color='primary' size='small' disabled={(filterTamplates==='talentsNewsletters')} onClick={() => setFilterTamplates('talentsNewsletters')}>Talents Newsletters</Button>
                        <Button color='primary' size='small' disabled={(filterTamplates==='JobSwipe')} onClick={() => setFilterTamplates('JobSwipe')}>JobSwipe</Button>
                        <Button color='primary' size='small' disabled={(filterTamplates==='notActive')} onClick={() => setFilterTamplates('notActive')}>Not Active</Button>
                    </div>
                </Paper>
                <Paper style={{margin:'2px 4px', position:'relative', overflow:'auto', height:'calc(100% - 41px)'}} elevation={1}>
                    <JSData cells={cells} data={filteredTemplates} handleEditRow={handleEditRow}/>
                </Paper>
            </>}
        </div>
    );
}